module.exports = __webpack_public_path__ + "static/media/Membership.e6b2094f.svg";